import { useState, useEffect } from 'react'

import Api from 'services/api'

const useEmailUnsubscribeStatus = (email, type) => {
  const [isUnsubscribed, setIsUnsubscribed] = useState<boolean>(false)
  const [areUnsubscribedLoaded, setAreUnsubscribedLoaded] = useState<boolean>(false)

  useEffect(() => {
    if (!email || !type) return

    setAreUnsubscribedLoaded(false)
    setIsUnsubscribed(false)

    Api.UnsubscribeEmails.get(email, type)
      .then((response) => {
        setIsUnsubscribed(Boolean(response))
      })
      .catch(() => {
        setIsUnsubscribed(false)
      })
      .finally(() => {
        setAreUnsubscribedLoaded(true)
      })
  }, [email, type])

  return { isUnsubscribed, areUnsubscribedLoaded, setIsUnsubscribed }
}

export default useEmailUnsubscribeStatus
